import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M36 4v16c0 2.25-1.812 4-4 4H12.813c-1.063 0-2.063-.375-2.813-1.125L.563 13.438C.188 13.062 0 12.562 0 12c0-.5.188-1 .563-1.375L10 1.188A3.98 3.98 0 0 1 12.813 0H32c2.188 0 4 1.813 4 4M16.938 6.938c-.625.625-.625 1.562 0 2.125L19.875 12l-2.937 2.938c-.625.624-.625 1.562 0 2.124.562.625 1.5.625 2.062 0l2.938-2.937 2.937 2.938c.625.625 1.563.625 2.125 0 .625-.563.625-1.5 0-2.125L24.063 12 27 9.063c.625-.563.625-1.5 0-2.126-.562-.562-1.5-.562-2.125 0l-2.937 2.938L19 6.938a1.47 1.47 0 0 0-2.062 0"
    }, null, -1)
  ]))]))
}
export default { render: render }